import React from "react";
import Footer from "../components/Footer";
import { useLocation } from "react-router-dom";

const FooterRouter = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  return (
    <div className="bg-black">
      <div className="xl:max-w-[1450px] m-auto">
        {currentPath !== "/contact" && (
          <div className="ssx:mt-[80px] lg:mt-[35px] ssx:mx-[10px] lg:mx-0">
            <Footer />
          </div>
        )}  
      </div>
    </div>
  );
};

export default FooterRouter;
